import { TableConfig } from '../../../../features/ui-config'
import { getConfigTranslation } from '../../../helper/getConfigTranslation'

export function createHeader(
  title?: string | JSX.Element,
  actions?: JSX.Element,
  config?: TableConfig,
) {
  const configTitle = getConfigTranslation(config?.title)

  if (!configTitle && !title && !actions) {
    return null
  }

  return (
    <div className="table-header flex justify-content-between flex-wrap align-items-center">
      <h3 className="mx-0 my-1">{configTitle || title}</h3>
      <div className="flex flex-wrap gap-2">{actions}</div>
    </div>
  )
}
